import { useState } from 'react';
import Chevron from '../chevron/Chevron';
import ButtonBase from '../button/ButtonBase';
import styles from './expandable.module.less';

const Expandable = ({
    children,
    className = '',
    childrenClassName,
    title,
    isOpen = false,
    addButtonPadding = true,
}) => {
    const [isExpanded, setIsExpanded] = useState(isOpen);
    return (
        <div className={className} aria-expanded={isExpanded}>
            <div>
                <ButtonBase
                    type="button"
                    onClick={() => {
                        setIsExpanded(!isExpanded);
                    }}
                    className={[styles.button, addButtonPadding ? styles.buttonPadding : ''].join(' ')}
                >
                    {title}
                    <Chevron isOpen={isExpanded} className={styles.icon} />
                </ButtonBase>
            </div>
            {isExpanded && (
                <div className={[styles.childrenContainer, childrenClassName].join(' ')} aria-live={'polite'}>
                    {children}
                </div>
            )}
        </div>
    );
};

export default Expandable;
